import React from 'react';
import banner from '../../assets/OurTeam.jpeg'; // Make sure this image exists
import hitendraImg from '../../assets/hitendra_singh.jpg';
import anshulImg from '../../assets/Anshul.jpg';

const team = [
  {
    name: 'Hitendra Singh Parihar',
    role: 'Soft Skills Trainer',
    desc: '6+ years of delivering impactful communication and leadership training.',
    img: hitendraImg,
  },
  {
    name: 'Anshul Saxena',
    role: 'Aptitude Trainer',
    desc: 'Expert in Quant, Reasoning, Verbal Ability with 8+ years mentoring 30,000+ students.',
    img: anshulImg,
  },
];

const OurTeam = () => {
  return (
    <div className="bg-white text-gray-800">
      {/* Hero with background image */}
      <section
        className="h-[280px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url(${banner})`,
        }}
      >
        <h1 className="text-4xl font-bold text-white bg-black/50 px-6 py-3 rounded-lg shadow-lg">
          Meet the Experts Behind Placify
        </h1>
      </section>

      {/* Team Cards */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto flex justify-center">
          <div className="grid sm:grid-cols-2 md:grid-cols-2 gap-10">
            {team.map((member, idx) => (
              <div
                key={idx}
                className="bg-white rounded-xl shadow-md hover:shadow-xl p-6 text-center transition-all duration-300 w-80"
              >
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto object-cover mb-4 shadow-md"
                />
                <h3 className="text-lg font-semibold text-blue-700">{member.name}</h3>
                <p className="text-sm text-gray-500 mb-2">{member.role}</p>
                <p className="text-sm text-gray-600">{member.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurTeam;
